import { useState } from 'react';

const AddEditGroupCodePopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAddEditGroupCodePopup, setShowAddEditGroupCodePopup] =
      useState<boolean>(false);

    const addGroupCodeToggleHandler = () => {
      setShowAddEditGroupCodePopup(!showAddEditGroupCodePopup);
    };

    return (
      <Component
        showAddGroupCodePopup={showAddEditGroupCodePopup}
        addGroupCodeToggleHandler={addGroupCodeToggleHandler}
        {...props}
      />
    );
  };

export default AddEditGroupCodePopupHOC;
